/* ==== FIX LIGHTBOX IMMAGINI (by Riccione in Moto) ==== */
document.addEventListener('DOMContentLoaded', () => {
  const fixModalImage = () => {
    const modal = document.querySelector('media-modal[open]');
    if (modal) {
      const modalContent = modal.querySelector('.media-modal__content');
      const modalImage = modal.querySelector('.media-modal__content img');
      
      if (modalContent) {
        modalContent.style.maxWidth = '90vw';
        modalContent.style.maxHeight = '90vh';
        modalContent.style.width = 'auto';
        modalContent.style.height = 'auto';
      }
      
      if (modalImage) {
        modalImage.style.maxWidth = '100%';
        modalImage.style.maxHeight = '100%';
        modalImage.style.width = 'auto';
        modalImage.style.height = 'auto';
        modalImage.style.objectFit = 'contain';
      }
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        setTimeout(fixModalImage, 50);
      }
    });
  });

  const modalElement = document.querySelector('media-modal');
  if (modalElement) {
    observer.observe(modalElement, { attributes: true });
  }
});
/* ==== FINE FIX ==== */
